module.exports = __webpack_public_path__ + "img/57.5.COD.28d83fc1.png";